<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-select v-model="subscriptionData.appid" @change="reloadList()" placeholder="请选择app" size="mini">
          <el-option
              v-for="item in appid_data"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-input placeholder="用户id" v-model="subscriptionData.userid" clearable size="mini"></el-input>
      </el-col>
      <el-col :span="6">
        <el-input placeholder="openid" v-model="subscriptionData.openid" clearable size="mini"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="模板id" v-model="subscriptionData.template_id" clearable size="mini"></el-input>
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="reloadList" size="mini">查询</el-button>
      </el-col>
      <el-col :span="6" style="margin-top:10px;">
        <el-input placeholder="模板别名" v-model="subscriptionData.template_name" clearable size="mini"></el-input>
      </el-col>
      <el-col :span="6" style="margin-top:10px;">
        <el-date-picker
            v-model="subscriptionData.beginTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
            value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-col>
    </el-row>
    <el-table
        :data="rowSubscriptionData"
        style="width: 100%;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
      <el-table-column prop="id" label="id" width="80"></el-table-column>
      <el-table-column prop="user_id" label="用户id" width="100"></el-table-column>
      <el-table-column prop="open_id" label="open_id"></el-table-column>
      <!-- <el-table-column prop="realname" label="姓名"></el-table-column> -->
      <!-- <el-table-column prop="age" label="年龄"></el-table-column> -->
      <el-table-column prop="template_name" label="模板别名"></el-table-column>
      <el-table-column prop="template_type" label="订阅类型"></el-table-column>
      <el-table-column prop="created" label="订阅时间" width="180" :formatter="formatDate"></el-table-column>
    </el-table>
    <div class="content-center content-top-padded block" style="margin-top: 10px;">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="subscriptionData.page"
          :page-sizes="[10, 20, 50, 100]"
          :total="subscriptionData.total_count"
          :page-size="subscriptionData.pageSize"
          layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getWxSubscriptionList
} from '@/api/wxa'

export default {
  name: 'Wxapp_templ_sub',
  data () {
    return {
      appid_data: [{
        value: 'wx47d38fb07875e1b0',
        label: '怡康到家'
      }, {
        value: 'wx5fbda51d446ddf0c',
        label: '怡康优选'
      }],
      rowSubscriptionData: [],
      subscriptionData: {
        page: 1,
        pageSize: 20,
        total_count: 0
      }
    }
  },
  methods: {
    formatDate (row) {
      let date = new Date(row.created * 1000)
      let year = date.getFullYear()
      let month = date.getMonth()
      let day = date.getDate()
      let hour = date.getHours()
      let min = date.getMinutes()
      let sec = date.getSeconds()
      return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec
    },
    handleCurrentChange (page) {
      this.subscriptionData.page = page
      this.reloadList()
    },
    reloadList () {
      let params = {
        'page': this.subscriptionData.page,
        'pageSize': this.subscriptionData.pageSize
      }
      if (this.subscriptionData.appid != null) {
        params['appid'] = this.subscriptionData.appid
      }
      if (this.subscriptionData.userid != null) {
        params['userid'] = this.subscriptionData.userid
      }
      if (this.subscriptionData.openid != null) {
        params['openid'] = this.subscriptionData.openid
      }
      if (this.subscriptionData.template_id != null) {
        params['template_id'] = this.subscriptionData.template_id
      }
      if (this.subscriptionData.template_name != null) {
        params['template_name'] = this.subscriptionData.template_name
      }
      if (this.subscriptionData.beginTime != null) {
        params['beginTime'] = this.subscriptionData.beginTime
      }
      getWxSubscriptionList(params).then(res => {
        this.rowSubscriptionData = res.data.data.list
        this.subscriptionData.total_count = res.data.data.total_count
      }).catch(error => {
        this.$message({
          type: 'error',
          message: error.message
        })
      })
    },
    handleSizeChange (size) {
      this.subscriptionData.page = 1
      this.subscriptionData.pageSize = size
      this.reloadList()
    }
  },
  mounted () {
    this.reloadList()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// wxapp_templ_sub.vue?3ba4d8c7